<template>
  <div>
    <div class="underline">
      <span class="checkboxes">
        <i v-if="value === true" class="fa fa-fw fa-check-square" aria-hidden="true" @click="updateValue(false)"></i>
        <i v-else class="fa fa-fw fa-square-o c5" aria-hidden="true" @click="updateValue(true)"></i>
      </span>
    </div>
    <under-label :id="'checkbox-' + this._uid"><slot></slot></under-label>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import UnderLabel from "./_UnderLabel.vue";

export default {
  name: "shared-under-checkbox",
  components: {
    UnderLabel
  },
  props: ["value", "disabled", "disableAutoSave"],
  computed: {
    ...mapGetters({ canEdit: "characters/canEdit" })
  },
  methods: {
    ...mapActions("characters", ["autoSave"]),
    updateValue(value) {
      if (this.canEdit) {
        this.$emit("input", value);
      }
    }
  },
  watch: {
    value() {
      if (!this.disableAutoSave) {
        this.autoSave();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/_global";

.underline {
  border-bottom: solid 1px $gray-400;
  font-weight: bold;
  font-size: 1.15em;
}
.checkboxes {
  cursor: pointer;
}
</style>
